import {
  CONTEXTUAL_getInstance2j6ylx8hc4yv2 as CONTEXTUAL_getInstance,
  PolymorphicKindla9gurooefwb as PolymorphicKind,
  PrimitiveKindndgbuh6is7ze as PrimitiveKind,
  LIST_getInstance2leq5bbahk4rz as LIST_getInstance,
  MAP_getInstance141vh6u7faopd as MAP_getInstance,
  ENUMlmq49cvwy4ow as ENUM,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import {
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ClassDiscriminatorMode_NONE_getInstance39dg6hx0yqfbs as ClassDiscriminatorMode_NONE_getInstance } from '../JsonConfiguration.mjs';
import {
  contextual3hpp1gupsu4al as contextual,
  SerializersModuleCollector3dddz14wd7brg as SerializersModuleCollector,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/modules/SerializersModuleCollector.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function checkKind($this, descriptor, actualClass) {
  var kind = descriptor.w1p();
  var tmp;
  if (kind instanceof PolymorphicKind()) {
    tmp = true;
  } else {
    tmp = equals(kind, CONTEXTUAL_getInstance());
  }
  if (tmp) {
    throw IllegalArgumentException().n2('Serializer for ' + actualClass.j1() + " can't be registered as a subclass for polymorphic serialization " + ('because its kind ' + kind.toString() + ' is not concrete. To work with multiple hierarchies, register it as a base class.'));
  }
  if ($this.m2t_1)
    return Unit_instance;
  if (!$this.n2t_1)
    return Unit_instance;
  var tmp_0;
  var tmp_1;
  if (equals(kind, LIST_getInstance()) || equals(kind, MAP_getInstance())) {
    tmp_1 = true;
  } else {
    tmp_1 = kind instanceof PrimitiveKind();
  }
  if (tmp_1) {
    tmp_0 = true;
  } else {
    tmp_0 = kind instanceof ENUM();
  }
  if (tmp_0) {
    throw IllegalArgumentException().n2('Serializer for ' + actualClass.j1() + ' of kind ' + kind.toString() + ' cannot be serialized polymorphically with class discriminator.');
  }
}
var JsonSerializersModuleValidatorClass;
function JsonSerializersModuleValidator() {
  if (JsonSerializersModuleValidatorClass === VOID) {
    class $ {
      constructor(configuration) {
        this.m2t_1 = configuration.o2o_1;
        this.n2t_1 = !configuration.w2o_1.equals(ClassDiscriminatorMode_NONE_getInstance());
      }
      p28(kClass, provider) {
      }
      s28(baseClass, actualClass, actualSerializer) {
        var descriptor = actualSerializer.a1n();
        checkKind(this, descriptor, actualClass);
      }
      t28(baseClass, defaultSerializerProvider) {
      }
      u28(baseClass, defaultDeserializerProvider) {
      }
    }
    protoOf($).r28 = contextual;
    initMetadataForClass($, 'JsonSerializersModuleValidator', VOID, VOID, [SerializersModuleCollector()]);
    JsonSerializersModuleValidatorClass = $;
  }
  return JsonSerializersModuleValidatorClass;
}
//region block: exports
export {
  JsonSerializersModuleValidator as JsonSerializersModuleValidator1v682i122jgoa,
};
//endregion

//# sourceMappingURL=JsonSerializersModuleValidator.mjs.map
